import { c as _c } from "react/compiler-runtime";
/**
 * Presentational only — renders nothing if points is falsy/0/null, so it's
 * safe to drop into a card unconditionally without an extra guard at the
 * call site. Covers both states you'll want:
 *  - loyalty program inactive for this shop -> backend returns 0 -> nothing shown
 *  - this specific variant excluded via an admin override (points_per_unit: 0) -> nothing shown
 *
 * <EarnPointsBadge points={pointsMap[product.variant_id]} />              // product card
 * <EarnPointsBadge points={points} size="lg" />                           // product detail page
 */
export default function EarnPointsProductBadge(t0) {
  const $ = _c(10);
  const {
    points,
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? "text-xs" : t1;
  const className = t2 === undefined ? "" : t2;
  if (!points || points <= 0) {
    return null;
  }
  const t3 = `flex items-center gap-1 py-1 leading-none mb-2 rounded ${className}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-orange-400 text-xs"><svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path fill="currentColor" d="M12 1L9 9l-8 3l8 3l3 8l3-8l8-3l-8-3z" /></svg></span>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const t5 = `leading-tight font-medium text-green-800 tracking-wider inline-flex w-full gap-1  ${size} ${className}`;
  let t6;
  if ($[1] !== points) {
    t6 = points.toLocaleString();
    $[1] = points;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const t7 = points === 1 ? "" : "s";
  let t8;
  if ($[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
    t8 = <div className="flex flex-col"><div title="Earn Loyalty Reward Points" className={t5}>{"You'll"} earn {t6} Reward Point{t7} for this purchase</div></div>;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t3 || $[8] !== t8) {
    t9 = <div className={t3}>{t4}{t8}</div>;
    $[7] = t3;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}